export type NumberValue = number | null;

export const INLINE = 'INLINE' as const;
export const LOZENGE = 'LOZENGE' as const;
export const NORMAL = 'NORMAL' as const;
export const CHILD_ISSUE_LOZENGE = 'CHILD_ISSUE_LOZENGE' as const;

export type FieldEditStyle = typeof INLINE | typeof NORMAL;
export type FieldFocusStyle = typeof LOZENGE | typeof NORMAL | typeof CHILD_ISSUE_LOZENGE;
